// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"9e962f7a","528":"9e962f7a","715":"9e962f7a","938":"9e962f7a"}[chunkId] + ".chunk.css";
};